import {css} from 'lit-element'; export default css`:host{grid-template-rows:var(--horizontal-panel-height) auto auto 1fr}`;
    